import React from 'react'
import { Routes, Route } from 'react-router-dom'

// 홈
import Dashboard from '../pages/Dashboard'

// 로그인
import SignIn from '../pages/signIn/SignIn'
import FindId from '../pages/signIn/FindId'
import ResetPassword from '../pages/signIn/ResetPassword'
import ChangePassword from '../pages/signIn/ChangePassword'
import Error from '../pages/Error'

// 404
import NoMatch from '../utils/NoMatch'
// agent POS
import AgentPOS from '../pages/agentPOS/AgentPOS'

const AuthRouter = () => {
  return (
    <>
      <Routes>
        {/* <Route path="/" element={<Dashboard />} /> */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/findid" element={<FindId />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/agentPOS" element={<AgentPOS />} />
        <Route path="/*" element={<SignIn />} />
        {/* <Route path="/error" element={<Error />} /> */}
        {/* <Route path="/*" element={<NoMatch />} /> */}
      </Routes>
    </>
  )
}

export default AuthRouter
